import type { Id } from '@/types/api';

const BG_COLORS = ['#FFE9C2', '#FFDCDC', '#E6F5FF', '#EDEBFF', '#E1FFDD'];

/**
 * Assigns a background color to each student in the provided array based on their ID.
 *
 * @param students - Array of student objects with `id`, `firstName`, and `lastName`.
 * @returns A map of student IDs to assigned background colors.
 */
export const assignColorToStudents = (students: { id: number; firstName: string; lastName: string }[]): Map<Id, string> => {
  const studentsMap = new Map<Id, string>();
  for (const [index, student] of students.entries()) {
    const colorIndex = index % BG_COLORS.length;
    studentsMap.set(student.id, BG_COLORS[colorIndex]);
  }
  return studentsMap;
};
